var map = {
	"./15/TSLA_USD_70.json": 76957,
	"./22/TSLA_USD_70.json": 99267,
	"./23/TSLA_USD_70.json": 41184,
	"./24/TSLA_USD_70.json": 95973,
	"./26/TSLA_USD_70.json": 52207,
	"./28/TSLA_USD_70.json": 76433,
	"./29/TSLA_USD_70.json": 55662,
	"./30/TSLA_USD_70.json": 55228,
	"./31/TSLA_USD_70.json": 48031,
	"./32/TSLA_USD_70.json": 7202,
	"./33/TSLA_USD_70.json": 46869,
	"./34/TSLA_USD_70.json": 82736,
	"./35/TSLA_USD_70.json": 30483
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5266;